import { consoleLogger } from '@shared/logging/consoleLogger';
import { getValidatedBase64Cookie } from '@shared/cookies/getValidatedBase64Cookie';
import { UtiqAskMeLater, UtiqStatusEntryName } from '@shared/constants/utiq';
import { showConsentManager } from '@utiqLoader/consentManager/showConsentManager';
import { initialiseConsentManagerUtiqApiFunctions } from '@utiqLoader/consentManager/initialiseConsentManagerUtiqApiFunctions';
import { setVersionCookies } from '@utiqLoader/helpers/setVersionCookies';

// initialise utiqConsentManager data
export const loadUtiqConsentManager = () => {
  const showUtiqConsentManager = () => showConsentManager();

  initialiseConsentManagerUtiqApiFunctions(showUtiqConsentManager);
  const statusCookie = getValidatedBase64Cookie(
    document.cookie,
    UtiqStatusEntryName,
  );
  // UPDS-898-traffective-ask-me-later-X-POC
  const isAskMeLaterEnabled =
    sessionStorage.getItem(UtiqAskMeLater) !== null
      ? JSON.parse(sessionStorage.getItem(UtiqAskMeLater)!)
      : false;

  if (!statusCookie && !isAskMeLaterEnabled) {
    consoleLogger.logInfo(
      'No consent status cookie found. Showing consent manager popup...',
    );
    setVersionCookies();
    showUtiqConsentManager();
  }
};
